import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellConstructionSizeM from './IconWellConstruction_size_m';

const props: CreateIconArguments = {
  l: IconWellConstructionSizeM,
  m: IconWellConstructionSizeM,
  s: IconWellConstructionSizeM,
  xs: IconWellConstructionSizeM,
  name: 'IconWellConstruction',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
